<!-- format.align==='right'?'text-end':'text-center'" -->
<div *ngIf="!col.isMerge" [ngClass]="{'text-start':col.align==='left',
                                      'text-center':(col.align==='center' || col.align===undefined),
                                      'text-end':col.align==='right',
                                      'fw-bold':col.isBold,
                                      'flex-fill bd-highlight':true
                                      }" [ngSwitch]="col.totalsRowFunction" style="padding-right: 0px;">


  <span *ngSwitchCase="'sum'">
    <span [ngSwitch]="col.dataType">
      <span *ngSwitchCase="columnDataTypeEnum.MONEY"> {{(ArrayUtils.sumByField(dataList, col.field).toFixed(col.roundDecimal?col.roundDecimal:2)| thousandSeparatorWithDecimals)}}</span>
      <span *ngSwitchCase="columnDataTypeEnum.DECIMAL"> {{(ArrayUtils.sumByField(dataList, col.field).toFixed(col.roundDecimal?col.roundDecimal:2)| thousandSeparatorWithDecimals)}}</span>
      <span *ngSwitchCase="columnDataTypeEnum.NUMBER"> {{(ArrayUtils.sumByField(dataList, col.field)| thousandSeparator)}}</span>
      <span *ngSwitchDefault> {{(ArrayUtils.sumByField(dataList, col.field).toFixed(col.roundDecimal?col.roundDecimal:2)| thousandSeparator)}}</span>
    </span>

  </span>

  <span *ngSwitchCase="'count'">
    {{dataList?.length}}
  </span>



  <span *ngSwitchDefault>

  </span>

</div>